import type { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | null = null;

/** Wired once from PlatformProvider so logout can drop cached API data. */
export function registerAuthQueryClient(client: QueryClient): void {
  queryClient = client;
}

export function clearAuthQueryCache(): void {
  queryClient?.clear();
}
